export class TlsSecretProbe {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ok",
            "baseName": "ok",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "hasRequiredKeys",
            "baseName": "hasRequiredKeys",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "notAfter",
            "baseName": "notAfter",
            "type": "string",
            "format": ""
        },
        {
            "name": "expiresInDays",
            "baseName": "expiresInDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "ProbeError",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TlsSecretProbe.attributeTypeMap;
    }
    constructor() {
    }
}
